import Vue from 'vue';
import Vuex from 'vuex';
import attendance from './modules/attendance';
import alert from './modules/alert';
import auth from './modules/auth';
import users from './modules/users';
import settings from './modules/settings';

const MobileDetect = require('mobile-detect');

let detect = new MobileDetect(window.navigator.userAgent);

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    attendance,
    alert,
    auth,
    users,
    settings,
  },
  state: {
    loading: false,
    sidebar: !detect.mobile(),
    mobile: detect.mobile(),
  },
  mutations: {
    startLoad(state) {
      state.loading = true;
    },
    stopLoad(state) {
      state.loading = false;
    },
    toggleSidebar(state) {
      state.sidebar = !state.sidebar;
    },
  },
  actions: {
  },
});
